/* eslint-disable filenames/match-regex */
import { AuthProvider } from 'layout/auth-provider';
import RequireAuth from 'layout/require-auth';
import Login from 'pages/authentication/login';
import Home from 'pages/home';
import { PaymentDetail } from 'pages/payment/payment-detail';
import React, { useEffect, useRef, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import PaymentComponent from 'pages/payment';
import OrderDetailComponent from 'pages/oder-paid/order-detail';
import OrderPaidComponent from 'pages/oder-paid';
import MergBill from 'pages/merge';
// import MergeOrderComponent from 'pages/merge';
import Order from 'pages/order/index';
import Flow from 'pages/flow';
import { toast, ToastContainer } from 'react-toastify';
import MergeOrderComponent from 'pages/merge';
import { useServiceWorker } from 'useServiceWorker';
import ModalCommon from 'components/Modal/ModalCommon/ModalCommon';
import { socket } from './Socket';
import { TypeSocket } from 'constants/AppEnums';
import { connect, useDispatch, useSelector } from 'react-redux';
import OrderAction from './redux/actions/order/orderAction';
import { AppState } from 'redux/store';
import { Box, Modal } from '@mui/material';
import { Language } from 'shared/Language';
import MyButton from 'components/Button.tsx';
import Img from 'assets/img/img_success.png';
import Format from 'utils/Format';
import { fetchInfoPrintOrder } from 'service/orderService';
import printService from 'components/PopupPrintfOder/printService';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
};


function AppV2() {
    const { waitingWorker, showReload, reloadPage } = useServiceWorker();
    const [isShowModalUpdate, setIsShowModalUpdate] = useState(false);
    const dispatch = useDispatch();
    const setPaymentReduce = (data) => dispatch<any>(OrderAction.setSocketPayment(data));
    const clearPaymentReduce = (data) => dispatch<any>(OrderAction.clearSocketPayment(data));
    const [dataSocket, setDataSocket] = useState<any>(null);
    const location = useLocation();
    const navigate = useNavigate();
    const orderIdCurrent = useRef<number>(null);
    const { currentOrderId } = useSelector((state: AppState) => state.currentOrderId);
    const [open, setOpen] = useState<boolean>(false);
    useEffect(() => {
        if (showReload && waitingWorker) {
            setIsShowModalUpdate(true);
        } else {
            setIsShowModalUpdate(false);
        }
    }, [waitingWorker, showReload, reloadPage]);

    useEffect(() => {
        try {
            socket.connect();
            startListeners();

        } catch (error) {
            console.error("Lỗi kết nối:", error);
        }
        return () => {
            socket.disconnect();
        };
    }, []);

    useEffect(() => {
        if (orderIdCurrent.current !== currentOrderId) orderIdCurrent.current = currentOrderId;
        // console.log('orderIdCurrent.current ==', orderIdCurrent.current);

    }, [currentOrderId]);

    const getInfoPrint = async (id: string | number) => {
        const res = await fetchInfoPrintOrder(id);
        if (res.message === 'Success') {
            const _data = res.metadata[0] as any;
            //await printService(_data);
        }
    };

    const startListeners = () => {
        socket.on(TypeSocket.CONNECT, (data) => {
            console.log("Connected to server");
        });
        socket.on(TypeSocket.POS, (data) => {
            setDataSocket(data);
            setPaymentReduce(data);
            // console.log('location ==', location?.pathname, location.pathname === `/order/${orderIdCurrent.current}`);
            // console.log('data ==', data, data?.orderId);
            // console.log('orderIdCurrent.current ==', orderIdCurrent.current);
            if (data?.orderId) getInfoPrint(data?.orderId);
            if (Number(data?.orderId) === Number(orderIdCurrent.current || 0)) {
                setOpen(true);
            } else {
                orderIdCurrent.current = 0;
                return toast.success(`${data?.notiName} \n Order No: ${data?.orderNo} \n Amount: ${Format.formatMoney(Number(data?.amount || 0))}` || 'Successfully', {
                    position: 'top-right',
                    theme: 'colored'
                });
            }
        });

        socket.on(TypeSocket.CONNECT_ERROR, (error) => {
            console.error("Connection error:", error);
        });
        socket.on(TypeSocket.CONNECT_TIMEOUT, () => {
            console.error("Connection timeout");
        });
        socket.on(TypeSocket.DISCONNECT, () => {
            console.log("Disconnected from server");
        });
    };

    const onFullScreen = () => {
        let elem = document.documentElement;
        const deviceInfo = (window.navigator.userAgent);
        if (!deviceInfo.includes('Mac OS') && !deviceInfo.includes('IOS') && !deviceInfo.includes('OS')) {
            if (!document.fullscreenElement) {
                elem.requestFullscreen({ navigationUI: 'show' }).then(() => {
                    screen.orientation.lock('landscape').catch((err) => {
                    });
                }).catch(err => {
                    // alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
                });
            }
        }
    };

    const onPressConfirm = () => {
        setOpen(false);
        clearPaymentReduce({});
        orderIdCurrent.current = 0;
        OrderAction.setCurrentOrderId(null);
        navigate('/order-paid');
    };

    return (
        <div id="page-main" onClick={onFullScreen}>
            <AuthProvider>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route
                        path="/payment"
                        element={
                            <RequireAuth>
                                <PaymentComponent />
                            </RequireAuth>
                        }
                    />
                    <Route
                        path="/payment-detail"
                        element={
                            <RequireAuth>
                                <PaymentDetail />
                            </RequireAuth>
                        }
                    />
                    <Route
                        path="/"
                        element={
                            <RequireAuth>
                                <Home />
                            </RequireAuth>
                        }
                    />
                    <Route
                        path="/order/:id"
                        element={
                            <RequireAuth>
                                <Order />
                            </RequireAuth>
                        }
                    />
                    <Route
                        path="/order-paid"
                        element={
                            <RequireAuth>
                                <OrderPaidComponent />
                                {/* <MergeOrderComponent/> */}
                            </RequireAuth>
                        }
                    />
                    <Route
                        path="/order-detail"
                        element={
                            <RequireAuth>
                                <OrderDetailComponent />
                            </RequireAuth>
                        }
                    />
                    <Route
                        path="/order-merge"
                        element={
                            <RequireAuth>
                                <MergeOrderComponent />
                            </RequireAuth>
                        }
                    />
                    <Route path="/flow" element={<Flow></Flow>} />
                    <Route path="/merge" element={<MergBill />} />
                </Routes>
            </AuthProvider>
            <ToastContainer />
            {dataSocket ? <Modal open={open} onBackdropClick={onPressConfirm}>
                <Box sx={style}>
                    <div className='popup-payment'>
                        <div className="popup-success">
                            <img src={Img} style={{ height: 150, width: 150 }} />
                            <div className="text-big-x bold color-black mgb-16">
                                {dataSocket?.notiName || 'Payment Success'}
                            </div>
                            <div className="text-big medium color-black mgb-16">Order No: {dataSocket ? dataSocket?.orderNo : ''}</div>
                            <div className="text-big medium color-black mgb-16">Amount: {dataSocket ? Format.formatMoney(Number(dataSocket?.amount || 0)) : Format.formatMoney(0)}</div>
                            <MyButton label={Language.common.confirm} styleContainer={'btn-success'} onPress={onPressConfirm} />
                        </div>
                    </div>
                </Box>
            </Modal> : null}
            {isShowModalUpdate && (
                <ModalCommon
                    onHandleClose={() => {
                        setIsShowModalUpdate(false);
                    }}
                    onConfirm={() => {
                        setIsShowModalUpdate(false);
                        reloadPage();
                    }}
                    show={isShowModalUpdate}
                    title="Cập nhật phiên bản mới"
                    content="Đã có phiên bản mới bạn vui lòng thực hiện cập nhật để có thể sử dụng tính năng mới nhất!!!"
                ></ModalCommon>
            )}
        </div>
    );
}

export default connect()(AppV2);



